import { LocalStorageKey } from "@/constants/constants";
import { useRouter } from "@/hooks/useRouter";
import { getLocalStorageItem } from "@/lib/localStorage";
import { findRouteInfo, normalizeRoutePath } from "@/lib/routeUtils";
import { layoutRoutes } from "@/router/routes";
import { userStore } from "@/stores/userStore";
import { useLocation } from "@solidjs/router";

// 检查当前路由是否有效
export function useValidRoute() {
  const location = useLocation();
  const { push } = useRouter();

  const isValidRoute = (pathname?: string) => {
    const path = pathname || location.pathname;
    // 使用工具函数查找目标路由的 info
    const normalPath = normalizeRoutePath(path);
    const routeInfo = findRouteInfo(
      layoutRoutes(),
      normalPath, // 处理目标路径：移除语言前缀、查询参数和开头的斜杠
    );

    if (routeInfo?.needKYC === true) {
      // TODO: 判断是否需要KYC验证
      console.log(routeInfo);
    }

    // 判断是否需要登录
    if (routeInfo?.needLogin === true) {
      return userStore.isLogin;
    }
    // 判断是否为游戏路由
    // 使用/传参的路由
    const witherList = ["game/", "game-detail/"];
    const isWither = witherList.some((item) => normalPath.includes(item));
    if (!routeInfo && isWither) {
      return userStore.isLogin;
    }
    return true;
  };
  // 处理未登录
  const handleNoLogin = () => {
    const lastLoginTime = getLocalStorageItem(LocalStorageKey.LastLoginTime, 0);
    // 判断是否登录过
    if (lastLoginTime) {
      push("/login");
    } else {
      push("/register");
    }
  };

  return { isValidRoute, handleNoLogin };
}
